<template>
  <div class="home fl">
    <Header />
    <FindAStockistPage />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import Header from "@/components/falken/Header/Header.vue";
import FindAStockistPage from "@/components/falken/FindAStockist/FindAStockist.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    Header,
    FindAStockistPage,
  }
});
</script>
